import React from "react";
import { graphql } from "gatsby";

import { WebPageWithSeo } from "../components/WebPage/WebPage";
import { HeroElementRenderer } from "../components/HeroElementRenderer";
import { ContentElementRenderer } from "../components/ContentElementRenderer";

import { getAnchorNavData } from "../lib/helper/getAnchorNavData";

export default function cameraTemplate(props) {
    if (!props.data.datoCmsCamera) {
        console.warn(
            `No Cms Data was loaded! On page: ${props.pageContext.id}, pageType: ${props.pageContext.pageType}`
        );
        return null;
    }

    const Hero = (
        <HeroElementRenderer items={props.data.datoCmsCamera.header} />
    );

    const Content = (
        <ContentElementRenderer
            items={props.data.datoCmsCamera.content}
            config={props.data.config}
        />
    );

    const anchorNavCameraData = {
        name: props.data.datoCmsCamera.name,
        price: props.data.datoCmsCamera.price,
        priceInfoText: props.data.datoCmsCamera.priceInfoText,
        priceLink: props.data.datoCmsCamera.priceLink
    };

    return (
        <WebPageWithSeo
            Hero={Hero}
            Content={Content}
            contactPerson={props.data.datoCmsCamera.pageArea.contactPerson}
            contactButton={props.data.datoCmsCamera.pageArea.contactButton}
            anchorNavData={getAnchorNavData(props.data.datoCmsCamera.content)}
            anchorNavCameraData={anchorNavCameraData}
            localeVariants={props.data.seo.localeVariants}
            entryPage={props.data.datoCmsCamera.pageArea.entryPage}
            seo={props.data.seo}
            photoCredit={props.pageContext?.copyrightAssets}
            breadcrumb={props.data.datoCmsCamera.breadcrumb}
            includedDomains={props.data.datoCmsCamera.showOnFollowingPages}
            finderCategories={props.data?.cameraCategories?.nodes}
            finderApplications={props.data?.cameraApplications?.nodes}
            cookieGroups={props.data.cookieGroups.nodes}
            {...props}
        />
    );
}

export const query = graphql`
    query CameraTemplateQuery(
        $id: String!
        $locale: String!
        $fallbackLocales: [String!]
        $navRootId: String!
        $satelliteNavRootId: String!
        $footerId: String!
        $imgAuto: String!
        $imgFormat: String!
        $hasQuickFinder: Boolean!
        $pageAreaId: String!
    ) {
        datoCmsCamera(
            id: { eq: $id }
            locale: $locale
            fallbackLocales: $fallbackLocales
            isActive: {eq: true}
        ) {
            ...cms_hero_camera
            ...cms_content_camera
            breadcrumb {
                ...breadcrumb
            }
            pageArea {
                ...entry_page
                ...contact_person
                ...contact_button
            }
            showOnFollowingPages {
                cmsLanguage
            }
            name
            price
            priceInfoText {
                blocks
                links
                value
            }
            priceLink {
                blocks
                links {
                    ...link_page
                }
                value
            }
        }
        alternatives: datoCmsCamera(
            locale: $locale
            fallbackLocales: $fallbackLocales
            id: { eq: $id }
        ) {
            _allSlugLocales {
                locale
                value
            }
        }
        seo: datoCmsCamera(
            id: { eq: $id }
            locale: $locale
            fallbackLocales: $fallbackLocales
            isActive: {eq: true}
        ) {
            ...seo_camera
        }
        config: datoCmsLanguageConfiguration(
            locale: $locale
            fallbackLocales: $fallbackLocales
            cmsLanguage: { eq: $locale }
        ) {
            ...config
        }
        navigation: datoCmsNavigationMain(
            id: { eq: $navRootId }
            locale: $locale
            fallbackLocales: $fallbackLocales
        ) {
            ...main_navigation
        }
        satelliteNavigation: datoCmsSatelliteNavigation(
            id: { eq: $satelliteNavRootId }
            locale: $locale
            fallbackLocales: $fallbackLocales
        ) {
            ...satellite_navigation
        }
        footerData: datoCmsNavigationFooter(
            id: { eq: $footerId }
            locale: $locale
            fallbackLocales: $fallbackLocales
        ) {
            ...footer
        }
        stdPages: datoCmsStandardPage(
            locale: $locale
            fallbackLocales: $fallbackLocales
        ) {
            ...default_pages
        }
        domains: allDatoCmsRegionAndDomain {
            nodes {
                ...domains
            }
        }
        cameraCategories: allDatoCmsCameraCategory(
            locale: $locale
            fallbackLocales: $fallbackLocales
        ) @include(if: $hasQuickFinder) {
            nodes {
                ...quick_finder_category
            }
        }
        cameraApplications: allDatoCmsApplicationAndIndustry(
            locale: $locale
            fallbackLocales: $fallbackLocales
        ) @include(if: $hasQuickFinder) {
            nodes {
                ...quick_finder_application
            }
        }
        campaigns: allDatoCmsCampaign(locale: $locale) {
            nodes {
                ...campaigns
            }
        }
        cookieGroups: allDatoCmsCookieGroup(locale: $locale) {
            nodes {
                ...cookieGroup
            }
        }
    }
`;
